import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { http } from "../../helpers/http";
const Footer = () => {
    const navigate = useNavigate();
    const [ques, setQues] = useState("");
    const QueSubmit = (e) => {
        e.preventDefault();

        http({
            method: "POST",
            url: "sendQuestion",
            isSecure: true,
            body: {
                question: ques,  // Use the value of ques, not setQues
            },
        });

        setQues("");
    };
    return (
        <footer>
            <div className="cus_container">
                <div className="footer-top">
                    <div className="d-lg-flex justify-content-between">
                        <div className="col-left">
                            <h3 className="head3">
                                <span className='text-white'> Have Question in mind?</span>
                                <br />
                                <span className='text-white'> Let us Help You</span>
                            </h3>
                        </div>
                        <div className="col-right mt-3 mt-lg-0">
                            <form onSubmit={QueSubmit}>
                                <div className="inputGroup d-sm-flex align-items-center">
                                    <input
                                        type="text"
                                        className="input_control"
                                        placeholder="Enter your question"
                                        onChange={(e) => setQues(e.target.value)}
                                        value={ques}
                                    />
                                    <button
                                        className="cusbtn ms-sm-2 mt-sm-0 mt-3"
                                        disabled={!ques}
                                        type='submit'
                                    >
                                        Submit</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
                <div className="footer-middle">
                    <div className="d-flex   flex-lg-row  flex-column justify-content-between align-items-center ">
                        <div className="footer-logo">
                            <img
                                src="./assets/img/Header_Logo.svg"
                                alt="logo"
                                onClick={() => navigate("")}
                            />
                            {/* <img src="/assets/img/footerlogo.svg" alt='logo' /> */}
                        </div>
                        <div className="footer-widget my-4 my-lg-0 mobile-w100 foolink">
                            <ul>
                                <li className="widget-title">
                                    <Link to="">Home</Link>
                                </li>
                                <li className="widget-title hdn_txt">
                                    <Link to="/restaurants">Restaurants</Link>
                                </li>
                                <li className="widget-title invisible">
                                    <Link to="aboutus">About Us</Link>
                                </li>
                                <li className="widget-title invisible">
                                    <Link to="contactus">Contact Us</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="footer-social invisible">
                            <ul>
                                <li className="social-title">
                                    <a target='_blank'>
                                        <img src="./assets/img/facebook.svg" alt="facebook" className="social-link" />
                                    </a>
                                </li>
                                <li className="social-title">
                                    <a target='_blank'>
                                        <img src="./assets/img/instagram.svg" alt="instagram" className="social-link" />
                                    </a>
                                </li>
                                <li className="social-title">
                                    <a target='_blank'>
                                        <img src="./assets/img/twitter.svg" alt="twitter" className="social-link" />
                                    </a>
                                </li>
                                <li className="social-title">
                                    <a target='_blank'>
                                        <img src="./assets/img/youtube.svg" alt="youtube" className="social-link" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
                <div className="footer_copyWr">
                    <div className="text-center text-white">   ©2023 Boomerang. All Right Reserved.</div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;

